import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { MENU } from "../../data/site";

export const Menu = () => {
  const [active, setActive] = useState(MENU[0].id);
  const cat = MENU.find((c) => c.id === active);

  return (
    <section id="menu" className="relative py-28 lg:py-40 bg-[var(--br-panel)] border-y border-[var(--br-gold)]/12" data-testid="menu">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="overline mb-5">The Menu</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-[var(--br-cream)] leading-[1.05]">
            Ethiopian fire, <span className="italic text-[var(--br-gold)]">continental favourites</span> & the bar.
          </h2>
        </Reveal>

        {/* Category tabs */}
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-2.5" data-testid="menu-tabs">
            {MENU.map((c) => (
              <button
                key={c.id}
                data-testid={`menu-tab-${c.id}`}
                onClick={() => setActive(c.id)}
                className={`rounded-full border px-5 py-2.5 text-xs sm:text-sm tracking-wide transition-all duration-300 ${
                  active === c.id
                    ? "bg-[var(--br-gold)] text-black border-[var(--br-gold)]"
                    : "border-[var(--br-gold)]/25 text-[var(--br-muted)] hover:text-[var(--br-cream)] hover:border-[var(--br-gold)]/60"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </Reveal>

        {/* Items */}
        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="mt-12"
          >
            {cat.note && <p className="mb-8 text-sm italic text-[var(--br-gold)]/80">{cat.note}</p>}

            <div className="grid gap-x-14 gap-y-9 md:grid-cols-2">
              {cat.items.map((it, i) => (
                <div key={it.name} className="group" data-testid={`menu-item-${active}-${i}`}>
                  <div className="flex items-baseline gap-4">
                    <h3 className="font-display text-xl sm:text-2xl text-[var(--br-cream)] group-hover:text-[var(--br-gold)] transition-colors duration-300">
                      {it.name}
                    </h3>
                    <span className="flex-1 border-b border-dotted border-[var(--br-gold)]/25 translate-y-[-4px]" />
                    <span className="font-display text-lg text-[var(--br-gold)] whitespace-nowrap">{it.price}</span>
                  </div>
                  {it.desc && <p className="mt-1.5 text-sm leading-relaxed text-[var(--br-muted)]">{it.desc}</p>}
                </div>
              ))}
            </div>

            {cat.tags && (
              <div className="mt-12 border-t border-[var(--br-gold)]/12 pt-8">
                <p className="overline mb-4 text-[10px]">{active === "hookah" ? "Flavors" : "On Tap & Bottled"}</p>
                <div className="flex flex-wrap gap-2.5">
                  {cat.tags.map((t) => (
                    <span key={t} className="rounded-full border border-[var(--br-gold)]/20 px-4 py-1.5 text-xs text-[var(--br-cream)]/80">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};
